var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEntregaDemoras(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FFB800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4899 11.418C22.9045 11.418 20.3772 12.1846 18.2275 13.621C16.0779 15.0573 14.4024 17.0989 13.413 19.4875C12.4236 21.876 12.1648 24.5044 12.6691 27.0401C13.1735 29.5758 14.4185 31.905 16.2466 33.7331C18.0748 35.5612 20.404 36.8062 22.9397 37.3106C25.4754 37.815 28.1037 37.5561 30.4923 36.5667C32.8808 35.5773 34.9224 33.9019 36.3588 31.7522C37.7951 29.6026 38.5618 27.0752 38.5618 24.4899C38.5618 22.7732 38.2237 21.0734 37.5667 19.4875C36.9098 17.9015 35.9469 16.4605 34.7331 15.2466C33.5193 14.0328 32.0782 13.0699 30.4923 12.413C28.9063 11.7561 27.2065 11.418 25.4899 11.418ZM30.7186 25.7971H25.4899C25.1432 25.7971 24.8107 25.6593 24.5655 25.4142C24.3204 25.169 24.1827 24.8366 24.1827 24.4899V19.2611C24.1827 18.9144 24.3204 18.5819 24.5655 18.3368C24.8107 18.0916 25.1432 17.9539 25.4899 17.9539C25.8366 17.9539 26.169 18.0916 26.4142 18.3368C26.6593 18.5819 26.7971 18.9144 26.7971 19.2611V23.1827H30.7186C31.0653 23.1827 31.3978 23.3204 31.643 23.5655C31.8881 23.8107 32.0258 24.1432 32.0258 24.4899C32.0258 24.8366 31.8881 25.169 31.643 25.4142C31.3978 25.6593 31.0653 25.7971 30.7186 25.7971Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntregaDemoras);
export default __webpack_public_path__ + "static/media/entrega-demoras.77517b1fc968251bfac41c28eb506f7f.svg";
export { ForwardRef as ReactComponent };